
import React from "react";
import {Button, Checkbox, Col, DatePicker, Input, message, Modal, Popover, Row, Spin, Tooltip,Select} from "antd";
import moment from "moment";
// import AlarmStatisticsAreaFenceModal from '../../StatisticsReport/components/AlarmStatisticsAreaFenceModal';
import WarningModalHandle from './WarningModalHandle.js'
import {SimpleTreeUpdate, WWTable,DeviceSearch,ExportFile,AuthButton} from '@/globalComponents'
import {WWUtils,WWMethods,wwConstants} from "@/tools";
import FenceInfoModal from "../../containers/Statistics/components/FenceInfoModal";
const {RangePicker} = DatePicker;
const {TextArea} = Input;
// moment.locale("zh-cn");
const Option = Select.Option;

class WarningMassageContentModal extends React.Component {
    constructor(props) {
        super(props);
        let speed = localStorage.getItem("speed")
        this.state = {
            visible: false,
            defineShow: false,
            accountId: localStorage.getItem("organizationId"),
            accountName: localStorage.getItem('accountName'),
            isFreeAccount: localStorage.getItem('isFreeAccount') == '1',
            alarmType: [],
            pageSize: 10,
            currentPage: 1,
            count: 0,
            startTime: moment().subtract(7, "days"),
            endTime: moment(),
            alarmId: [],
            checkedId: '',
            alarmTypeArray: [],
            judgeType: '',
            judgeTypeAll: '',
            remark: '',
            info: '',
            selectKeys: [],
            isTakeSub: 0,
            messageList: [],
            selectAlarmId: [],
            showMph: speed == "km/h" ? false : true,
            isGoogle: localStorage.getItem('isGoogleMap'),
            isGoogleSatellite: localStorage.getItem('isGoogleSatelliteMap'),
            imei:"",
            carId:""
        };
        this.close = this.close.bind(this);
        this.getMessageList = this.getMessageList.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.handleDeviceListChange = this.handleDeviceListChange.bind(this);
        this.openDefineone = this.openDefineone.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.handleAllSave = this.handleAllSave.bind(this);
        this.getOptions = this.getOptions.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.formSearchParams = this.formSearchParams.bind(this);
        this.getMessages = this.getMessages.bind(this);
        this.updateAddress = this.updateAddress.bind(this);
        this.handleDeviceChange = this.handleDeviceChange.bind(this);
        this.showFenceModal = this.showFenceModal.bind(this);
        this.showModalMessage = this.showModalMessage.bind(this);
        this.disabledDate = this.disabledDate.bind(this)
    }
    componentDidMount() {

    }
    //日历控件操作
    disabledDate  (current) {
        const {startTime,endTime} = this.state;
        return WWMethods.disabledDate(current,[startTime,endTime])
    }
    showModalMessage(){
        this.setState({
            visible: true,
            isGoogle: localStorage.getItem('isGoogleMap'),
            isGoogleSatellite: localStorage.getItem('isGoogleSatelliteMap'),
            messageList: [],
            accountName: localStorage.getItem('organizationName'),
            startTime: moment().subtract(7, "days"),
            endTime: moment(),
            imei: '',
            judgeType: '',
            accountId: localStorage.getItem("organizationId"),
            alarmType: []
        },()=>{
            this.refs.simple && this.refs.simple.updateDatas_simple({
                treeVisible:false,
                popVisible:false,
                showSelect:true,
                expandKeys:[localStorage.getItem('organizationId')],
                selectedKeys:[localStorage.getItem('organizationId')],
                organizationId:[localStorage.getItem('organizationId')],
                showRootName:true,
                organizationName:localStorage.getItem('organizationName'),
                isTallTree:true
            });
            this.getOptions()
        })
    }
    //获取推送的报警配置
    getOptions() {
        let that = this;
        let url = WWMethods.getApiUrl("orgConfig");
        //报警推送配置
        url += `?entityId=${localStorage.getItem("organizationId")}&entityType=1&configType=202`;
        WWUtils.fetch(url,'GET',(data)=> {
            if(data && data.code === 0 && data.data) {
                let config_init = data.data.items;
                //IOP是checked；mic是enable
                if(config_init){
                    localStorage.setItem("warningType", JSON.stringify(config_init));
                    let temp_options = Array.from(config_init);
                    let array = temp_options.filter((item)=> {
                        return item.hasOwnProperty("enable") && item.enable === 1
                    })
                    let obj_alarm = {
                        alarmTypeArray: array
                    }
                    if(!array.length){
                        obj_alarm.loading = false;
                    }
                    that.setState(obj_alarm,()=> {
                        if(array.length){
                            this.getMessageList()
                        }
                    });
                }

            }
        })



    }
    //组装报警信息查询参数
    formSearchParams(){
        let that = this;
        const {startTime, endTime, carId, isTakeSub,currentPage,pageSize, accountId, alarmType, judgeType} = this.state;
        let model = {};
        model.currentPage = currentPage;
        model.pageSize = pageSize;
        model.timeRange = {
            start:moment(startTime).startOf("day").unix(),
            end:moment(endTime).endOf("day").unix()
        }
        model.orgId = accountId;
        model.alarmTypes = alarmType;
        model.handle = judgeType;
        model.isTakeSub = isTakeSub;
        model.carId = carId;
        return model;
    }
    //报警列表的count接口
    getMessageList() {
        let that = this;
        that.setState({
            loading: true,
        });
        let url = WWMethods.getApiUrl("alarmDetailCount")
        WWUtils.fetch(url, "POST", this.formSearchParams(), (data) => {
            if (data && data.code === 0) {
                that.setState({
                        loading: false,
                        count: data.data,
                    },()=>{
                    that.getMessages()
                });
            } else {
                message.error(data.message);
                that.setState({
                    loading: false,
                });
            }
        });
    }
    //获取报警列表
    getMessages(){
        let url = WWMethods.getApiUrl("alarmDetailList")
        WWUtils.fetch(url, "POST", this.formSearchParams(), (data) => {
            if (data && data.code === 0) {
                this.setState({
                    loading: false,
                    messageList: data.data,
                });
            } else {
                message.error(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    //列表分页处理
    handleAccountChange(orgId, accountName, isGetSubAccounts) {
        this.setState({
            accountName,
            accountId: orgId
        })
    }
    onTimeChange(date, dateString) {
        this.setState({
            startTime: date ? date[0] : "",
            endTime: date ? date[1] : "",
        });
    };


    /**
     * 翻页控件处理
     * @param currentPage
     */
    handleDeviceListChange(currentPage) {
        this.setState({
            currentPage:currentPage
        },()=>{
            this.getMessages();
        })

    }
    //多选
    onSelectChange(selectedRowKeys, selectedRows) {
        let deviceAlarmIds = selectedRows.map((item) => {
            return item.id
        })
        this.setState({alarmId: deviceAlarmIds, selectKeys: selectedRowKeys});
    };
    //批量处理-确定
    handleAllSave() {
        const {judgeTypeAll, remark, alarmId} =
            this.state;

        if (!judgeTypeAll) {
            message.error(Strings.rs11063);
            return;
        }
        let model = {
            handle: judgeTypeAll,
            handleRemark:remark,
            ids: alarmId,
        };
        let url = WWMethods.getApiUrl("alarmHandle");
        let that = this;
        WWUtils.fetch(url, "POST", model, function (data) {
            if (data.code === 0) {
                message.success(Strings.rs11064);
                that.setState({
                    defineShow: false,
                    selectKeys: []
                }, () => {
                    that.getMessageList();
                })
            } else {
                message.error(data.message);
            }
        });
    }

    close() {
        this.setState({
            visible: false,
            selectKeys: [],
            pageSize: 10,
            currentPage: 1,
            count: 0
        });
    }
    //单个处理报警
    openDefineone(record) {
        // this.setState({loading: true})
        this.refs.alarm.showModal(record)
    }
    //查看地址，获取地址详情
    updateAddress(lat,lng,mapType,index){
        const {messageList} = this.state;
        let temp_ms_list = Array.from(messageList);
        WWMethods.getAddressDetail(lat,lng,(address)=>{
            temp_ms_list[index].address = address;
            this.setState({messageList:temp_ms_list})
        })
    }
    //模糊搜索设备机械编号、选择设备
    handleDeviceChange (carId) {
        this.setState({carId});
    }
    showFenceModal(fenceId,imei,alarmTime){
        let mapType = WWUtils.getCurMapType();
        let coordinate = WWUtils.getMapTypeCoordinate(mapType);
        ///mic/alarm-record/fence-alarm-detail
        this.refs.fence.showModal(fenceId,imei,alarmTime)

    }
    render() {
        let that = this;
        const dateFormat = "YYYY-MM-DD";
        const {showMph, loading, judgeType, judgeTypeAll, isTakeSub, selectKeys, alarmType, isFreeAccount, accountName,alarmId,
            imei, startTime, alarmTypeArray, remark, endTime, isGoogle, isGoogleSatellite,accountId,count,pageSize,currentPage} = this.state;
        let options = alarmTypeArray.map(function (item) {
            return <Option key={item.name} value={item.code}>{item.name}</Option>
        });
        const rowSelection = {
            columnWidth: '5%',
            selectedRowKeys: selectKeys,
            onChange: this.onSelectChange,
        };
        const columns = [
            {
                title: Strings.rs10164,
                dataIndex: "alarmType",
                width: "10%",
                render:(text,record)=> {
                    return WWUtils.getLabelFromGlobalEnums("enums.alarmType",null,text)
                }
            },
            {
                title: Strings.rs10163,
                dataIndex: "alarmTime",
                width: "10%",
                render: function (text, record) {
                    return WWUtils.formatTimeYMDHms(text);
                },
            },
            {
                title: Strings.carCode,
                dataIndex: "carCode",
                width: "10%",
                render: function (text, record) {
                    return (
                        <p className="ellipsis" title={text}>
                            {text}
                        </p>
                    );
                },
            },
            {
                // title: "设备号",
                title: Strings.imei,
                width: "12%",
                dataIndex: "imei",
            },
            {
                // title: showMph ? "速度(mp/h)" : "速度(km/h)",//todo 单位获取
                title: showMph ? Strings.rs10524 : Strings.rs10168,
                dataIndex: "speed",
                width: "10%",
                render: function (text, col, index) {
                    let speed = text
                    if (speed && localStorage.getItem('speed') === "mp/h") {
                        speed = parseFloat(speed) / 1.609
                        speed = parseFloat(speed).toFixed(2)
                    }
                    return <sapn>{speed}</sapn>
                },
            },
            {
                // title: "位置",
                title: Strings.address,
                dataIndex: "address",
                width: "12%",
                render: function (text, record,index) {
                    let mapType = 1;
                    if (isGoogle === '1' || isGoogleSatellite === '1') {
                        mapType=0
                    }
                    return (
                       text?text: (record.lng &&  record.lat)? <a onClick={()=>{
                            that.updateAddress(record.lat,record.lng,mapType,index)
                        }}>{Strings.getAddress || "获取位置"}</a> : <span></span>
                    )
                },
            },
            {
                // title: "其它详情",
                title: Strings.rs10266,
                dataIndex: "",
                width: "10%",
                render: (text, record) => {
                    return (record.extInfoBean? record.extInfoBean.name? <a onClick={()=>{
                        this.showFenceModal(record.extInfoBean.id,record.imei,record.alarmTime)
                    }}>{record.extInfoBean.name}</a> : record.extInfoBean.desc: "");

                },
            },
            {
                // title: "处理结果",
                title: Strings.rs11052,
                dataIndex: "",
                width: "8%",
                render: function (text, record) {
                    let desc = WWUtils.getLabelFromGlobalEnums("enums.alarmHandle",null,record.handle);

                    return <Popover transitionName="" style={{width: '50px'}} placement="bottom"
                                    content={record.handleRemark}>
                        <span>{desc}</span>
                    </Popover>
                },
            },
            {
                // title: "操作",
                title: Strings.opts,
                dataIndex: "",
                width: "8%",
                render: function (text, record) {
                    return (
                        <a onClick={() => {
                            that.openDefineone(record)
                        }}>{Strings.rs11057}</a>
                    );
                },
            },
        ];
        return (
            <div>
                <Modal transitionName="" maskTransitionName=""
                       className="default_modal"
                       visible={this.state.visible}
                       width={1350}
                       onCancel={this.close}
                       maskClosable={false}
                       title={Strings.rs10199}
                       footer={null}
                >
                    <Spin delay={2000} spinning={loading}>
                        <div className="searchWrapper mgt30">
                            <div className="firstRow searchRow alt">
                                <div className={"searchDiv"}>
                                    <div className={"searchItem"}>
                                        <div className={"item"}>
                                            <span className="label w100p">{Strings.rs10035} </span>
                                            <div className={"warningMsg_tree_wrapper mgl7"} style={{display:"inline-block",position:"relative"}}>
                                                <SimpleTreeUpdate
                                                    selectWidth={240}
                                                    margins={"5px auto"}
                                                    ref="simple"
                                                    parentClass={`warningMsg_tree_wrapper`}
                                                    directShowTree={false}
                                                    showRootName={true}
                                                    organizationId={accountId}
                                                    handleChange={this.handleAccountChange}
                                                    sendAccountId={this.handleAccountChange}
                                                />
                                            </div>

                                        </div>
                                        <div className={"item mgt15"}>
                                            <span className="label w100p">{Strings.rs10164} </span>
                                            <Select className={"mgl7"}
                                                    value={alarmType}
                                                    placeholder={Strings.all}
                                                    mode="multiple"
                                                    style={{width: 240}}
                                                    dropdownMatchSelectWidth={false}
                                                    onChange={(value) => {
                                                        this.setState({alarmType: value})
                                                    }}>
                                                {options}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className={"searchItem"}>
                                        <div className={"item"}>
                                            <span className="label w100p">{Strings.machineCodeOrImei || "机械编号/设备号"} </span>
                                            <div className={"item w240 mgl7"}>
                                                <DeviceSearch ref={"messageRef"} className={"mg15"} onChange={this.handleDeviceChange}/>
                                            </div>
                                        </div>
                                        <div className={"item mgt15"}>
                                            <span className="label w100p">{Strings.rs11052} </span>
                                            <Select className={"mgl7"}
                                                style={{width: 240}}
                                                dropdownMatchSelectWidth={false}
                                                value={judgeType}
                                                onChange={(value) => {
                                                    this.setState({judgeType: value});
                                                }}>
                                                <Option  value={""}>{Strings.rs11053}</Option>
                                                {WWUtils.getOptionsFromGlobalEnums("enums.alarmHandle","select")}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className={"searchItem"}>
                                        <div className={"item"}>
                                            <span className="label w100p">{Strings.rs10163} </span>
                                            <RangePicker className={"mgl7"}
                                                style={{width: 240, marginRight: '20px'}}
                                                value={[startTime, endTime]}
                                                         disabledDate={this.disabledDate}
                                                // placeholder={["开始时间", "结束时间"]}
                                                placeholder={[Strings.rs10276, Strings.rs10277]}
                                                onChange={this.onTimeChange}
                                                format={dateFormat}
                                                showTime={false}
                                            />
                                        </div>
                                        <div className={"item mgt15"}>
                                            <Checkbox
                                                checked={Boolean(isTakeSub)}
                                                onChange={(e) => {
                                                    this.setState({
                                                        isTakeSub: Number(e.target.checked),
                                                    });
                                                }}>{Strings.takeSub}
                                            </Checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div className={"btnswrapper"}>
                                    <AuthButton type="primary" authKey={true}  onClick={() => {
                                       this.setState({currentPage:1},()=>{
                                           this.getMessageList()
                                       })
                                    }}>{Strings.search || "搜索"}</AuthButton>
                                </div>
                            </div>
                        </div>
                        <div className="border_table">
                            <div className={"bathOptsWrapper"}>
                                <div className={"leftopts"}>
                                    <AuthButton type="primary" className={"mgl0"}  authKey={true}  onClick={() => {
                                        alarmId.length >=1 ? this.setState({defineShow: true}):message.error(Strings.atLeastOneAlarm || "请至少选择一条报警")}}>{Strings.rs12301}</AuthButton>
                                </div>
                                <ExportFile params={this.formSearchParams()} type={"alarmRecord"} ></ExportFile>
                            </div>
                            <WWTable
                                rowSelection={rowSelection}
                                pagination={false}
                                innerHeight={490}
                                height={480}
                                className="new_app_table"
                                columns={columns}
                                dataSource={this.state.messageList}
                                pageSize={pageSize}
                                onChange={this.handleDeviceListChange}
                                onShowSizeChange={(currentPage,pageSize)=>{
                                    this.setState({currentPage:1,pageSize},()=>{
                                        this.getMessageList();
                                    })
                                }}
                                count={count}
                                currentPage={currentPage}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </Spin>
                </Modal>

                <Modal transitionName="" maskTransitionName=""
                       visible={this.state.defineShow}
                       width={400}
                       onCancel={() => this.setState({remark: '', judgeTypeAll: '', defineShow: false})}
                       title={Strings.rs11059}
                       footer={null}
                       className="default_modal wid650">
                    <div className="onlyOneRow modal_item">
                        <span className="labelfont">{Strings.rs11063}</span>
                        <div className="form_value">
                            <Select value={judgeTypeAll} onChange={(value) => {
                                this.setState({
                                    judgeTypeAll: value
                                })
                            }} style={{width: 240}}>
                                {WWUtils.getOptionsFromGlobalEnums("enums.alarmHandle","select")}
                            </Select>
                        </div>
                    </div>
                    <div className="onlyOneRow modal_item">
                        <span className="labelfont">{Strings["prop.common.remark"]}</span>
                        <div className="form_value">
                            <Input type='textarea' value={remark} style={{width: 240, height: 100,}}
                                maxLength={240}
                                onChange={(e) => {
                                    this.setState({
                                        remark: e.target.value
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className="btn-row mg_top5">
                        <AuthButton type={"reset"} authKey={true} onClick={this.hideModal}>{Strings.cancel}</AuthButton>
                        <AuthButton  authKey={true}  type="primary" onClick={this.handleAllSave}>{Strings.sure}</AuthButton>
                    </div>
                </Modal>

               {/* <AlarmStatisticsAreaFenceModal idName={'alarm_detail'} ref="alarmStatisticsAreaFenceModal"/>
               */}
                <WarningModalHandle ref="alarm" refresh={this.getMessageList} loadingClose={() => {
                    this.setState({loading: false})
                }}/>
                <FenceInfoModal ref="fence" ></FenceInfoModal>

            </div>
        );
    }
}

export default WarningMassageContentModal;
